import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useGetClinicOwners = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const getClinicOwners = async () => {
    // Fetch clinic owners
    setLoading(true);
    try {
      const response = await apiService.getClinicOnwers();
      response && setData(response?.map(item => ({
        label: item?.userName,
        value: item?.userSub
      }))); // update data state
      return response;
    } catch (error) {
      console.log('Fetch Clinic Owners Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    getClinicOwners,
  };
};
